export enum Alerts {
  EmptyMerchantAccess = 'empty_merchant_access',
  EmptyProviderAccountAccess = 'empty_provider_account_access',
}
